import { QueryHookOptions, QueryResult, useQuery } from '@apollo/client';
import { Logger } from '@indigo-ag/ui-core';
import { DocumentNode } from 'graphql';
import React from 'react';

import { LoadingIndicator } from '../LoadingIndicator/LoadingIndicator';

interface LoadingWrapperProps {
  query: DocumentNode;
  queryOptions?: QueryHookOptions;
  children: (result: QueryResult) => JSX.Element;
}

export const LoadingWrapper: React.FunctionComponent<LoadingWrapperProps> = ({ query, queryOptions, children }) => {
  const isPollingQuery = !!queryOptions?.pollInterval;
  const queryResult = useQuery(query, queryOptions);
  const { loading, error, stopPolling } = queryResult;
  if (isPollingQuery && error) {
    Logger.warn('Encountered error during LoadingWrapper polling. Stopping poll requests.');
    stopPolling();
  }
  return loading ? <LoadingIndicator /> : children(queryResult);
};

/* How to use it?
export const YourComponent: React.FunctionComponent = () => {
  return (
    <LoadingWrapper query={YOUR_QUERY}>
      {
        ({ data }) => {
          return <div>My data {JSON.stringify(data)}</div>;
        }
      }
    </LoadingWrapper>
  );
};
*/
